import SubmissionsView from 'broker/components/SubmissionsView';
import { SubmissionViewMode } from 'broker/components/SubmissionsView/utils';

export default function RetailerSubmissionsPage() {
  return <SubmissionsView viewMode={SubmissionViewMode.Retailer} />;
}
